import * as React from "react";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "./App.css";

import InputForm from "./components/InputForm";
import ResultsGrid from "./components/ResultsGrid";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
};

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = { results: [], helpOpen: false };
  }

  render() {
    return (
      <div className="App">
        <img src="./Logo.png"></img>
        <h2>RetireNow - The Retire Now Simulator</h2>
        <Button variant="outlined" onClick={this.openHelp.bind(this)}>
          Show Help
        </Button>
        <Modal
          keepMounted
          open={this.state.helpOpen}
          onClose={this.closeHelp.bind(this)}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="keep-mounted-modal-title"
              variant="h4"
              component="h2"
            >
              Help (Some information about this Simulator)
            </Typography>
            <div id="keep-mounted-modal-description" >
              This simulator assumes a 80/20 split in SCHD and MGK

              <Typography variant="h4">Input</Typography>
              <ul>
                <li>Inflation Rate: Average rate of inflation</li>
                <li>Investment Balance: Current investment balance</li>
                <li>Yearly Expenses: Yearly Expenses</li>
                <li>Start Age: Age to start retirement</li>
                <li>End Age: Age to end retirement (estimated death)</li>
                <li>
                  Age of Full Retirement: Age of full retirement (start
                  withdraws from IRAs)
                </li>
                <li>
                  Retirement Balance: Balance in retirement accounts (IRA etc)
                </li>
                <li>Marginal Tax Rate: Marginal Tax rate on income</li>
                <li>Income: Income from options or other sources</li>
                <li>Income Increase Rate: Rate at which income will increase yearly</li>
                <li># of Trials: Number of trials to run</li>
              </ul>
              <Typography variant="h4">Results</Typography>
              <ul>
                <li> Age: Age during simulated year</li>
                <li>MGK Shares: Number of MGK Shares</li>
                <li>SCHD Shares: Number of SCHD Shares</li>
                <li>MGK Investment Return %: Simulated MGK market return %</li>
                <li>SCHD Investment Return %: Simulated SCHD market return %</li>
                <li>MGK Investment Return $: Simulated MGK market return $</li>
                <li>SCHD Investment Return $: Simulated SCHD market return $</li>
                <li>MGK Dividend per share Return: Dividend amount per share</li>
                <li>SCHD Dividend per share Return: Dividend amount per share</li>
                <li>Dividends: Total Dividends</li>
                <li>
                  Net Income: Income from dividends and other sources after
                  taxes
                </li>
                <li>
                  Investment Withdraw: Withdraw amount to maintain reserve
                  balance
                </li>
                <li> Taxes: Taxes paid on income and withdraws </li>
                <li> Expenses: Expenses adjusted for inflation </li>
                <li> Income Over Expenses: Any income over expenses (left over after paying expenses) </li>
                <li> Investment Balance: Current balance of investments </li>
              </ul>

              <Typography variant="h4">Logic</Typography>

              <ul>
                <li>If full retirement age met then start using retirement</li>
                balance to buy more SCHD
                <li>
                  Yearly expenses increase yearly at the rate of inflation
                </li>
                <li>
                  Retirement balance increases yearly based on simulated return
                  and stops age 60 when it starts being used
                </li>
                <li> Net income is dividends + net income amount </li>
                <li >Withdraw amount is taxed at tax rate </li>
                <li> SCHD Starting Price: 70.16 (can be updated in the "Advanced" section) </li>
                <li> MGK Starting Price: 222.39 (can be updated in the "Advanced" section) </li>
                <li> SCHD Dividend per share: $2.64 (can be updated in the "Advanced" section) </li>
                <li> MGK Dividend per share: $1.24 (can be updated in the "Advanced" section) </li>
                <li> SCHD Dividend growth rate: 10.03% (can be updated in the "Advanced" section) </li>
                <li> MGK Dividend growth rate: 3% (can be updated in the "Advanced" section) </li>
              </ul>
            </div>
          </Box>
        </Modal>
        <InputForm
          results={this.state.results}
          onResultsChange={(results) => {
            this.setState({ results: results });
          }}
        />
        <ResultsGrid results={this.state.results} />
      </div>
    );
  }

  openHelp(){
    this.setState({ helpOpen: true });
  }

  closeHelp(){
    this.setState({ helpOpen: false });
  }
}

export default App;
